import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from '../services/common/token.service';
import { BaseService } from '../services/common/base.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CaoService extends BaseService {

  protected http: HttpClient;

  constructor(http: HttpClient, tokenService: TokenService) {
    super(tokenService);
    this.http = http;
  }



  // InsertFarmerApplicationApprovalRemarks(appId: String, userId: String, remarks: String, statusValue: String) {
  //   return this.http.post(`${environment.apiUrl}DashBoard/InsertFarmerApplicationApprovalRemarks?AppId=${appId}&Userid=${userId}&Remarks=${remarks}&Status=${statusValue}`, {responseType: 'text'});
  // }

  getMISubsidyLotNos() {
    return this.http.get<any>(`${environment.apiUrl}Department/GetMISubsidyLotNos`);
  }

  getMIPFMSExport(lotNo: string) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetMIPFMSExport?LotNo=${lotNo}`);
  }

  // getDataToPrintMultipleChallanAtal(userId: String) {
  //   return this.http.post(`${environment.apiUrl}Challan/GetDataToPrintMultipleChallanAtal?RequestType=${userId}`, {});
  // }


  miFarmerShareToVendorPFMSReport(reqBody: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIFarmerShareToVendorPFMSReport?UserType=${reqBody.UserType}&FinYear=${reqBody.FinYear}`);
  }

  getApplicationsForMIFarmerShareToVendorPFMSCAOReport(reqBody: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIFarmerShareToVendorPFMSCAOReport?UserType=${reqBody.UserType}&FinYear=${reqBody.FinYear}`);
  }

  miSubsidyToVendorPFMSReport(reqBody: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToVendorPFMSReport?UserType=${reqBody.UserType}&FinYear=${reqBody.FinYear}`);
  }

  miSubsidyToVendorCAOPFMSReport(reqBody: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToVendorPFMSCAOReport?UserType=${reqBody.UserType}&FinYear=${reqBody.FinYear}`);
  }

  miSubsidyToFarmerPFMSReport(reqBody: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToFarmerPFMSReport?UserType=${reqBody.UserType}&FinYear=${reqBody.FinYear}`);
  }

  miSubsidyToFarmerCAOPFMSReport(reqBody: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToFarmerPFMSCAOReport?UserType=${reqBody.UserType}&FinYear=${reqBody.FinYear}`);
  }

  getApplicationsForMISubsidyToFarmerPFMSReportABY(userType: string) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToFarmerPFMSReportABY?UserType=${userType}`);
  }

  miRefundToFarmerPFMSReport(reqBody: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIRefundToFarmerPFMSReport?UserType=${reqBody.UserType}&FinYear=${reqBody.FinYear}`);
  }

  getApplicationsForMIRefundToFarmerPFMSCAOReport(reqBody: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIRefundToFarmerPFMSCAOReport?UserType=${reqBody.UserType}&FinYear=${reqBody.FinYear}`);
  }

  miFarmerShareToVendorPFMSExport(lotId, status, userType) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIFarmerShareToVendorPFMSExport?LotNo=${lotId}&Status=${status}&UserType=${userType}`);
  }

  miSubsidyToVendorPFMSExport(lotId, status, userType) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToVendorPFMSExport?LotNo=${lotId}&Status=${status}&UserType=${userType}`);
  }

  getAppsForLotDetailsEPC(lotId) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetAppsForLotDetailsEPC?LotNo=${lotId}`);
  }

  miSubsidyToFarmerPFMSExport(lotId, status, userType) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMISubsidyToFarmerPFMSExport?LotNo=${lotId}&Status=${status}&UserType=${userType}`);
  }

  miRefundToFarmerPFMSExport(lotId, status, userType) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForMIRefundToFarmerPFMSExport?LotNo=${lotId}&Status=${status}&UserType=${userType}`);
  }

  importMIPFMSSubsidyToFarmer_Vendor(reqBody) {
    return this.http.post<any>(`${environment.apiUrl}Department/ImportMIPFMSSubsidyToFarmer_Vendor`, reqBody);
  }

  importMIPFMSFarmerShareToVendor_RefundToFarmer(reqBody) {
    return this.http.post<any>(`${environment.apiUrl}Department/ImportMIPFMSFarmerShareToVendor_RefundToFarmer`, reqBody);
  }

  importPondPFMSSubsidyToFarmer(reqBody) {
    return this.http.post<any>(`${environment.apiUrl}Department/ImportPFMSPond`, reqBody);
  }

  //Pond PFMS tank stage reports by Stage ID
  getApplicatonsForPondSubsidyPFMSReportsByStageId(reqBody: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondSubsidyToFarmerPFMSReport?Stage=${reqBody?.Stage}&UserType=${reqBody?.UserType}&FinYear=${reqBody?.FinYear}`);
  } 

  getApplicationsForPondSubsidyToFarmerPFMSCAOReport(reqBody: any) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondSubsidyToFarmerPFMSCAOReport?Stage=${reqBody?.Stage}&UserType=${reqBody?.UserType}&FinYear=${reqBody?.FinYear}`);
  } 

  getApplicationsForPondFarmerShareToVendorPFMSExportByLotId(lotId, stageId, status, userType) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondFarmerShareToVendorPFMSExport?LotNo=${lotId}&Stage=${stageId}&Status=${status}&UserType=${userType}`);
  }

  getDataForLotCertificate(lotId, userType) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetDataForLotCertificate?LotNo=${lotId}&UserType=${userType}`);
  }

  getDataForLotCertificate_STV(lotId, userType) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetDataForLotCertificate_STV?LotNo=${lotId}`);
  }

  getDataForLotCertificate_EPC(lotId) {
    return this.http.get<any>(`${environment.apiUrl}Department/GetDataForLotCertificate_EPC?LotNo=${lotId}`);
  }


}
